// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1295":"ec4243ed","2664":"acacc22c","3181":"70658e90","7449":"acacc22c","7666":"78f0f9ac","8332":"ec4243ed","9396":"acacc22c","9488":"acacc22c"}[chunkId] + ".chunk.css";
};